import { Alert, Snackbar } from '@mui/material';
import { AlertSeverity } from '../../contexts/AlertContext';
import './AlertSnackbar.scss';

interface AlertSnackbarProps {
  open: boolean;
  message: string;
  severity: AlertSeverity;
  onClose: () => void;
}

export const AlertSnackbar = ({ open, message, severity, onClose }: AlertSnackbarProps) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      style={{ zIndex: 1300 }}
    >
      <Alert onClose={onClose} severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  );
};
